/*  MUI  */
import { Box } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

/* internal */
import { FilterTitle } from './internal/FilterTitle';
import { StyleText } from './internal/StyleText';

export const releaseHeader = (releases) => {
    const currentReleaseFilterChildren = [];

    releases.forEach((release) => {
        let value = release;
        if (release === '1.9.1') {
            value = '';
        }

        currentReleaseFilterChildren.push({
            default: false,
            key: release,
            name: release,
            parameter: 'release',
            value
        });
    });

    const filters = [
        {
            children: currentReleaseFilterChildren,
            default: true,
            key: 'releases',
            name: 'Common.versions'
        }
    ];

    const filterableOptions = [];

    filters.forEach((f) => {
        const { key, children } = f;

        // Add this if a visible parent is necessary
        // filterableOptions.push({
        //     ...f,
        //     children: children.map((c) => c.key),
        //     optionHeader: true, // visualOnly
        //     parent: true,
        //     render: (
        //         <StyleText
        //             style={{ fontSize: FontSizes[1], fontWeight: 600 }}
        //             text={name}
        //         />
        //     ),
        //     value: key
        // });

        children.forEach((c) => {
            filterableOptions.push({
                ...c,
                child: true,
                parentKey: key,
                render: (
                    <Box display="flex" alignItems="center">
                        <StyleText
                            key={`text_${c.key}`}
                            style={{ fontSize: FontSizes[1] }}
                            text={c.name}
                        />
                    </Box>
                ),
                value: c.key
            });
        });
    });

    const parentKeys = ['releases'];

    // optionsHeaders - keys to parents
    // optionsSelected - values that should be checked by default
    // optionsToShow - values to display, adding parentKeys is necessary if parent headers will be shown
    return {
        field: 'release',
        filterableOneOption: false, // Can have multiple options checked.
        name: 'release',
        options: filterableOptions,
        optionsHeaders: ['releases'],
        optionsSelected: [],
        optionsToShow: [...releases, ...parentKeys],
        searchable: true,
        title: <FilterTitle title="Common.versionFilter" />
    };
};
